import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';


import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-doitaikhoanedit',
  templateUrl: './doitaikhoanedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./doitaikhoanedit.component.scss'],
    providers: [ListService, Repository]
})


export class doitaikhoaneditComponent implements OnInit {
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, LopId: null, Thu: null
    , TuNgay: null, DenNgay: null, GhiChu: null
    ,Created: null, Modified: null, CreatedBy: null, ModifiedBy: null

  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputthus: any = [
    { Ten: 'Thứ 2', Id: 2 },
    { Ten: 'Thứ 3', Id: 3 },
    { Ten: 'Thứ 4', Id: 4 },
    { Ten: 'Thứ 5', Id: 5 },
    { Ten: 'Thứ 6', Id: 6 },
    { Ten: 'Thứ 7', Id: 7 },
    { Ten: 'Chủ nhật', Id: 8 }
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  Password: string = null;
  PasswordNew: string = null;
  PasswordConfirm: string = null;
  username: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  hosoid: string;
  TaiKhoan: string;
 
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata : any, hocvienid: string) {
          this.hosoid = hocvienid;
          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            this.username = this.currentUser.user_name;
            //var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
            //if (giatri != null && giatri.length > 0) {
            //  if (giatri[0].Them == true)
            //    this.quyen_them = true;
            //  else
            //    this.quyen_them = false;
            //  if (giatri[0].Sua == true)
            //    this.quyen_sua = true;
            //  else
            //    this.quyen_sua = false;
            //  if (giatri[0].Xoa == true)
            //    this.quyen_xoa = true;
            //  else
            //    this.quyen_xoa = false;
            //}

            

          }    

       
    
       
   }
   
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    public closeModal(){
        this.save.emit(null);
    }
  DoiMatKhau() {
    if (this.TaiKhoan ==null) {
      swal('Lỗi!', "Vui lòng nhập tài khoản mới.", 'error');
      return;
    }
    let datat = {
      PassMoi: this.PasswordNew,
      PassCu: this.Password,
      HoSoId: this.hosoid,
      TaiKhoan: this.TaiKhoan,
      UserName: this.username
    };
    this.repo.postRequest("api/Login/doitaikhoanhocvien/", datat
    )
      .subscribe(response => {
        if (response != null && response.match('OK_')) {
          //this.Password = this.PasswordConfirm = this.PasswordNew = null;
          swal('Saved!', 'Đã đổi tài khoản thành công!.', 'success');
          this.save.emit(null);

        }
        else if (response != null) {
          swal('Lỗi!', response, 'error');
        }

        console.log(response);

      });
  }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


   


}
